import { render, staticRenderFns } from "./uploadImgJavah.vue?vue&type=template&id=3d081138&"
import script from "./uploadImgJavah.vue?vue&type=script&lang=js&"
export * from "./uploadImgJavah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports